import React from "react";

const industries = () => {
  return (
    <>
      <section className="services box lficon section-padding position-re industry">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="sec-head  text-center">
                <h2 className="wow color-font sec-title">
                  Industries we serve
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 wow fadeInLeft">
              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-utensils"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Resturants</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-sign-hanging"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Real Estate</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-cart-shopping"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">E-Commerce</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-school"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Education</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-laptop-file"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Saas</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-newspaper"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">News</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-dice"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Entertainment</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-truck-fast"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Logistics</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-plane"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Travel</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-sack-dollar"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Finance</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-bolt"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">EV</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-wheat-awn"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Agriculture</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-calendar-days"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Events</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-volleyball"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Sports</p>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div>
                  <span className="color-font fa-solid fa-hand-holding-medical"></span>
                </div>
                <div className="cont">
                  <p className="industry-title">Health Care </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default industries;
